import { createCrudService } from './createCrudService';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { MOCK_ROLES } from 'mock/roles.mock';

export const toRole = (raw) =>
  raw && {
    id: raw.id,
    roleName: raw.role_name ?? raw.roleName ?? '',
    description: raw.description ?? '',
    permissions: raw.permissions ?? {},
    allowed_newspapers: raw.allowed_newspapers ?? ['ALL'],
    status: raw.status,
    isSystem: raw.is_system ?? raw.isSystem ?? false,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };

const toPayload = (model) => ({
  role_name: model.roleName,
  description: model.description,
  permissions: model.permissions,
  allowed_newspapers: model.allowed_newspapers,
  status: model.status,
});

export const roleService = createCrudService({
  endpoints: API_ENDPOINTS.ROLES,
  toModel: toRole,
  toPayload,
  mockSeed: MOCK_ROLES,
  idPrefix: 'role',
});

export default roleService;
